module.exports = __webpack_public_path__ + "img/94.6.CODm.31038277.png";